import Permissoes from "@/utils/permissoes";

import { formMode } from "@/utils/form.helpers";

const routes = [
    {
      path: "/parametros/dados-empresa",
      name: "parametros-dados-empresa",
      component: () => import("@/views/configuracoes/dados-empresa"),
      meta: {
        title: 'Parâmetros - Dados da Empresa',
        authRequired: true,
        formMode: formMode.View,
        permissoes: [Permissoes.ParametrosDadosEmpresa],
        menus: [Permissoes.Configuracoes, Permissoes.ParametrosDadosEmpresa]
      },
    },
    {
      path: "/parametros/enderecos-destinacao",
      name: "parametros-enderecos-destinacao",
      component: () => import("@/views/configuracoes/enderecos-destinacao"),
      meta: {
        title: 'Parâmetros - Endereços Destinação',
        authRequired: true,
        formMode: formMode.View,
        permissoes: [Permissoes.ParametrosEnderecosDestinacao],
        menus: [Permissoes.Configuracoes, Permissoes.ParametrosEnderecosDestinacao]
      },
    },
    {
      path: "/parametros/tipos-cacamba",
      name: "parametros-tipos-cacamba",
      component: () => import("@/views/configuracoes/tipos-cacamba"),
      meta: {
        title: 'Parâmetros - Tipos de Caçamba',
        authRequired: true,
        formMode: formMode.View,
        permissoes: [Permissoes.ParametrosTiposCacamba],
        menus: [Permissoes.Configuracoes, Permissoes.ParametrosTiposCacamba]
      },
    },
    {
      path: "/parametros/dias-turnos",
      name: "parametros-dias-turnos",
      component: () => import("@/views/configuracoes/dias-turnos"),
      meta: {
        title: 'Parâmetros - Dias e Turnos',
        authRequired: true,
        formMode: formMode.View,
        permissoes: [Permissoes.ParametrosDiasTurnos],
        menus: [Permissoes.Configuracoes, Permissoes.ParametrosDiasTurnos]
      },
    },
    {
      path: "/parametros/tipo-carroceria",
      name: "parametros-tipo-carroceria",
      component: () => import("@/views/configuracoes/tipos-carroceria"),
      meta: {
        title: 'Parâmetros - Tipos de Veículos',
        authRequired: true,
        formMode: formMode.View,
        permissoes: [Permissoes.ParametrosTipoCarroceria],
        menus: [Permissoes.Configuracoes, Permissoes.ParametrosTipoCarroceria]
      },
    },

    {
      path: "/cadastros/tipos-residuos",
      name: "tipos-residuos",
      component: () => import("@/views/cadastros/tipos-residuos/index.vue"),
      meta: {
        title: 'Tipos de Resíduos',
        authRequired: true,
        permissoes: [Permissoes.VisualizarResiduos],
        menus: [Permissoes.Configuracoes, Permissoes.TiposResiduos]
      },
    },
    {
      path: "/cadastros/tipos-residuos/visualizar/:id",
      name: "tipos-residuos-visualizar",
      component: () => import("@/views/cadastros/tipos-residuos/form.vue"),
      meta: {
        title: 'Tipos de Resíduos',
        authRequired: true,
        formMode: formMode.View,
        permissoes: [Permissoes.VisualizarResiduos],
        menus: [Permissoes.Configuracoes, Permissoes.TiposResiduos]
      },
    },
    {
      path: "/cadastros/tipos-residuos/editar/:id",
      name: "tipos-residuos-editar",
      component: () => import("@/views/cadastros/tipos-residuos/form.vue"),
      meta: {
        title: 'Tipos de Resíduos',
        authRequired: true,
        formMode: formMode.Edit,
        permissoes: [Permissoes.EditarResiduos],
        menus: [Permissoes.Configuracoes, Permissoes.TiposResiduos]
      },
    },
    {
      path: "/cadastros/tipos-residuos/cadastrar",
      name: "tipos-residuos-cadastrar",
      component: () => import("@/views/cadastros/tipos-residuos/form.vue"),
      meta: {
        title: 'Tipos de Resíduos',
        authRequired: true,
        formMode: formMode.Create,
        permissoes: [Permissoes.CriarResiduos],
        menus: [Permissoes.Configuracoes, Permissoes.TiposResiduos]
      },
    },
    
  ];
  export default routes;

  